export class RouteNames{
   static caretakers: string = 'caretakers';
   static doctors: string = 'doctors';
   static patients: string = 'patients';
   static accounts: string = 'accounts';
   static assingPersons: string = 'add-persons';
}

